import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import renderLocale from '../../../_shared/helpers/renderLocale';
import { AppThunk } from '../../../store';
import { COOKIES } from '../../../_shared/constants/cookies';
import { httpHeaders } from '../../../_shared/constants/httpMethods';
import ReducerConstants from '../../../_shared/constants/reducers';
import { Auth, format, initialState } from './state';
import ApiService from '../../../_shared/api/apiService';
import { getCookie } from '../../../_shared/utils/cookies';
import { localStorageService } from '../../../services/StorageService';

const lang = renderLocale();
const deviceIdentifier = httpHeaders.clientIdentifier;
const clientVersion = '3.0';
const deviceType = {
  Web: 2
};
const auth = 'auth';

const loginReducer = (state, action: PayloadAction<Auth>) => ({
  ...state,
  ...action.payload
});

const request = {
  accessToken: getCookie(COOKIES.AUTH_TOKEN),
  actAsUniversalUserDealerId: getCookie(COOKIES.USER_ID),
  lang,
  deviceType: deviceType.Web,
  deviceIdentifier,
  clientVersion
};

export const authSlice = createSlice({
  name: ReducerConstants.AUTH,
  initialState,
  reducers: {
    loginReducer
  }
});

export const login = (loginRequest = request): AppThunk => async dispatch => {
  const authLoginFromLocal = localStorageService.getItem(auth);

  // Hydrate the redux store from local storage content
  if (
    authLoginFromLocal &&
    authLoginFromLocal.user &&
    authLoginFromLocal.user.universalUserDealerId ===
      parseInt(getCookie(COOKIES.USER_ID), 10)
  ) {
    dispatch(authSlice.actions.loginReducer(authLoginFromLocal));
  } else {
    // Else make login API call
    const client = await ApiService();
    const response = await client.apis.auth.login({
      request: {
        request: loginRequest
      }
    });

    const formattedResponse = format(response.body);

    localStorageService.setItem(auth, formattedResponse);

    // TODO: Add mutation here to save only the data that components will require
    dispatch(authSlice.actions.loginReducer(formattedResponse));
  }
};

export default authSlice.reducer;
